var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormulateInput',{attrs:{"type":"date","id":_vm.control.id,"name":_vm.control.name,"placeholder":_vm.control.placeholder,"help":_vm.control.help,"label":_vm.control.label,"required":_vm.control.required},model:{value:(_vm.control.value),callback:function ($$v) {_vm.$set(_vm.control, "value", $$v)},expression:"control.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }